import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["port", "encryption"]
  }

  select() {
    let port = parseInt(this.portTarget.value)

    if (port === 465) {
      this.encryptionTarget.value = "ssl"
    } else if (port === 587) {
      this.encryptionTarget.value = "starttls"
    }
  }

  fillPort() {
    if (this.encryptionTarget.value === "") {
      return
    } else if (
      this.encryptionTarget.value === "ssl" &&
      this.portTarget.value !== "" &&
      this.portTarget.value !== "587"
    ) {
      return
    } else if (
      this.encryptionTarget.value === "starttls" &&
      this.portTarget.value !== "" &&
      this.portTarget.value !== "465"
    ) {
      return
    }

    if (this.encryptionTarget.value === "ssl") {
      this.portTarget.value = 465
    } else if (this.encryptionTarget.value === "starttls") {
      this.portTarget.value = 587
    }
  }
}
